import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoadingScreen from "@/components/LoadingScreen";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Leistungen from "@/pages/Leistungen";
import UeberAuralia from "@/pages/UeberAuralia";
import FAQ from "@/pages/FAQ";
import Kontakt from "@/pages/Kontakt";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import LegalPage from "@/pages/LegalPage";
import Fragebogen from "@/pages/Fragebogen";
import "@/App.css";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? children : <Navigate to="/admin/login" replace />;
}

function WithLayout({ children }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}

function AppContent() {
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      {!loaded && <LoadingScreen onComplete={() => setLoaded(true)} />}
      <div
        style={{
          opacity: loaded ? 1 : 0,
          transition: "opacity 0.4s ease",
          pointerEvents: loaded ? "auto" : "none",
        }}
      >
        <Routes>
          <Route
            path="/"
            element={
              <WithLayout>
                <Home />
              </WithLayout>
            }
          />
          <Route
            path="/leistungen"
            element={
              <WithLayout>
                <Leistungen />
              </WithLayout>
            }
          />
          <Route
            path="/ueber-auralia"
            element={
              <WithLayout>
                <UeberAuralia />
              </WithLayout>
            }
          />
          <Route
            path="/faq"
            element={
              <WithLayout>
                <FAQ />
              </WithLayout>
            }
          />
          <Route
            path="/kontakt"
            element={
              <WithLayout>
                <Kontakt />
              </WithLayout>
            }
          />
          <Route
            path="/fragebogen"
            element={
              <WithLayout>
                <Fragebogen />
              </WithLayout>
            }
          />
          <Route
            path="/impressum"
            element={
              <WithLayout>
                <LegalPage type="impressum" />
              </WithLayout>
            }
          />
          <Route
            path="/datenschutz"
            element={
              <WithLayout>
                <LegalPage type="datenschutz" />
              </WithLayout>
            }
          />
          <Route
            path="/agb"
            element={
              <WithLayout>
                <LegalPage type="agb" />
              </WithLayout>
            }
          />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}
